export const EVC_NODE_DEFAULT = `
<EvcNode 
    id='{id}'
    title='{label title best-alias id}'
    description='{description}'
    encoding='{smiles inchi}'
    category='{category | upper}'
/>
`;
